var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"print-pay-slip"},[(_vm.payslip && _vm.payslipSettings)?_c('PayslipTable',{attrs:{"payslip":_vm.payslip,"payslipSettings":_vm.payslipSettings}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }